import { render, staticRenderFns } from "./NotMatchedEmployeeView.vue?vue&type=template&id=85840908&"
import script from "./NotMatchedEmployeeView.vue?vue&type=script&lang=js&"
export * from "./NotMatchedEmployeeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports